(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function() {
    const headers = document.querySelectorAll('[data-component="header"]');

    headers.forEach((header) => {
      const itemsWithChildren = header.querySelectorAll('[data-has-submenu]');

      itemsWithChildren.forEach((item) => {
        const link = item.querySelector(':scope > a');
        if (! link) return;
        


        link.addEventListener('click', (event) => {
          const hoverCapable = window.matchMedia('(hover: hover)').matches;
          if (hoverCapable) return;
          


          if (item.dataset.open === 'true') return;
          


          event.preventDefault();
          itemsWithChildren.forEach((other) => {
            if (other !== item) {
              other.removeAttribute('data-open');
            }

            const otherLink = other.querySelector(':scope > a');
            if (otherLink && other !== item) {
              otherLink.setAttribute('aria-expanded', 'false');
            }
          });

          item.setAttribute('data-open', 'true');
          link.setAttribute('aria-expanded', 'true');
        });
      });

      const closeAllSubmenus = () => {
        itemsWithChildren.forEach((item) => {
          item.removeAttribute('data-open');
          const link = item.querySelector(':scope > a');
          if (link) {
            link.setAttribute('aria-expanded', 'false');
          }
        });
      };

      document.addEventListener('click', (event) => {
        if (!header.contains(event.target)) {
          closeAllSubmenus();
        }
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          closeAllSubmenus();
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-media"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function handleClick(event) {
      var button = event.currentTarget;
      var section = button.closest('[data-hero-media]');
      if (!section) return;
      // Shopify wraps every section in a `.shopify-section` element; the next
      // storefront section is that wrapper's sibling, not ours. Walk up so a
      // preceding header doesn't leave the hero partially in view.
      var wrapper = section.closest('.shopify-section') || section;
      var next = wrapper.nextElementSibling;
      if (next) {
        next.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        // Fallback: scroll by the distance from the current viewport top to
        // the wrapper's bottom edge — correct regardless of where the hero
        // sits on the page.
        window.scrollBy({ top: wrapper.getBoundingClientRect().bottom, behavior: 'smooth' });
      }
    }
    function attemptPlay(video) {
      var p = video.play();
      if (p && typeof p.catch === 'function') {
        p.catch(function () {
          // Browser blocked autoplay (rare for muted, but possible). Resume on
          // the first user interaction anywhere on the page.
          var resume = function () {
            video.play().catch(function () {});
            document.removeEventListener('touchstart', resume);
            document.removeEventListener('click', resume);
            document.removeEventListener('keydown', resume);
          };
          document.addEventListener('touchstart', resume, { once: true, passive: true });
          document.addEventListener('click', resume, { once: true });
          document.addEventListener('keydown', resume, { once: true });
        });
      }
    }
    function bootstrapVideo(video) {
      // Force muted at the property level — some engines honor only the property, not the attribute.
      video.muted = true;
      video.defaultMuted = true;
      // If the browser already has enough data, play immediately; otherwise wait for canplay.
      if (video.readyState >= 3) {
        attemptPlay(video);
      } else {
        var onReady = function () {
          video.removeEventListener('canplay', onReady);
          video.removeEventListener('loadeddata', onReady);
          attemptPlay(video);
        };
        video.addEventListener('canplay', onReady);
        video.addEventListener('loadeddata', onReady);
        // Nudge the browser to start fetching now (some browsers throttle preload="auto").
        try { video.load(); } catch (e) {}
      }
    }
    // Videos marked `data-hero-media-lazy` ship with preload="none" and no
    // autoplay attribute, so nothing is fetched until they near the viewport.
    // The 200px margin starts the download just before the video scrolls in.
    function bootstrapWhenNear(video) {
      // preload must flip to "auto" before bootstrapping on every path: with
      // "none" and no autoplay attribute, `load()` fetches nothing and the
      // `canplay` that starts playback never fires.
      if (!('IntersectionObserver' in window)) {
        video.preload = 'auto';
        bootstrapVideo(video);
        return;
      }
      var observer = new IntersectionObserver(
        function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (!entries[i].isIntersecting) continue;
            observer.unobserve(entries[i].target);
            entries[i].target.preload = 'auto';
            bootstrapVideo(entries[i].target);
          }
        },
        { rootMargin: '200px 0px' }
      );
      observer.observe(video);
    }
    function initVideos(root) {
      var videos = root.querySelectorAll('[data-hero-media-video]');
      for (var i = 0; i < videos.length; i++) {
        if (videos[i].hasAttribute('data-hero-media-lazy')) {
          bootstrapWhenNear(videos[i]);
        } else {
          bootstrapVideo(videos[i]);
        }
      }
    }
    function init() {
      var buttons = document.querySelectorAll('[data-hero-media-scroll]');
      for (var i = 0; i < buttons.length; i++) {
        buttons[i].addEventListener('click', handleClick);
      }
      initVideos(document);
    }
    // The theme editor swaps a section's markup in place without reloading the
    // page. A lazy video has no `autoplay` attribute to fall back on, so it
    // would sit on its poster until re-bootstrapped.
    document.addEventListener('shopify:section:load', function (event) {
      initVideos(event.target);
      var buttons = event.target.querySelectorAll('[data-hero-media-scroll]');
      for (var i = 0; i < buttons.length; i++) {
        buttons[i].addEventListener('click', handleClick);
      }
    });
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
